import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SdsForm } from "soft_digi";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";
import * as Yup from "yup";
import Zone from "./Zone";
import SessionReport from "./SessionReport";
import { useSiteContext } from "../../contexts/SiteProvider";
import { post } from "../../services/smartApiService";
import { REPORT_URLS } from "../../api/AdminUrls";
import ProjectTraineereport from "./ProjectTraineereport";
import ProjectSessionReport from "./ProjectSessionReport";
import { formatDate } from "soft_digi/dist/services/CommonService";

const Reports = () => {
  const [selectedReport, setSelectedReport] = useState<number | null>(null);
  const [formData, setFormData] = useState<any>(null);
  const { setTitle } = useSiteContext();
  useEffect(() => {
    setTitle("Report");
  }, []);
  const schema = Yup.object({
    start_select: Yup.object()
      .shape({
        value: Yup.number()
          .typeError("Select is required")
          .required("Select is required"),
      })
      .required("Report selection is required"),
  
    start_date: Yup.string()
      .nullable()
      .when("start_select.value", {
        is: (value: any) => ![2].includes(value), 
        // then: (schema) => schema.required("From date is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
  
    end_date: Yup.string()
      .nullable()
      .when("start_select.value", {
        is: (value: any) => ![2].includes(value),
        // then: (schema) => schema.required("To date is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
  
    project_name: Yup.object()
      .nullable()
      .when("start_select.value", {
        is: (value: any) => [3, 4].includes(value), 
        then: (schema) => schema.required("Project selection is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
  });

  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });
  const [tabData, setTabData] = useState<any[]>([]);
  const Zonereports = [
    { value: 2, label: "Session Report" },
    { value: 3, label: "Project Wise Session Report" },
    { value: 4, label: "Project Wise Loco Pilot Report" },
  ];

  const onSubmit = (data: any) => {
    let url = "";
    let payload: any = {
      ...data,
      start_date: formatDate(data.start_date, "DD-MM-YYYY"),
      end_date: formatDate(data.end_date, "DD-MM-YYYY"),
    };

    switch (data.start_select.value) {
      case 1:
        url = REPORT_URLS.GET_ALL_SECTION;

        break;
      case 2:
        url = REPORT_URLS.GET_ALL_SECTION;

        break;
      case 3:
        url = REPORT_URLS.GET_ALL_SESSION_REPORT;

        break;
      case 4:
        url = REPORT_URLS.GET_ALL_TRAINEE_REPORT;

        break;
      default:
        return;
    }
    const subscription = post(url, payload).subscribe((response) => {
      setFormData(data);
      setSelectedReport(Number(data.start_select?.value));
      setTabData(response.data);
    });

    return () => subscription.unsubscribe();
  };
  const having_login = watch("start_select");

  const elements: SdsFormElementProps[] = [
    {
      type: "SELECT_BOX",
      width: 3,
      name: "start_select",
      element: {
        label: "Sessions Report",
        isRequired: true,
        options: Zonereports,
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "SELECT_BOX",
      width: 3,
      name: "project_name",
      element: {
        label: "Select Project",
        isRequired: true,
        options: [
          { value: "ALL", label: "ALL" },
          { value: "WR", label: "WR" },
          { value: "NCR", label: "NCR" },
          { value: "WCR", label: "WCR" },
          { value: "SCR", label: "SCR" },
          { value: "ER", label: "ER" },
        ],
        inputType: "BORDER_LABEL",
      },
      hideFunction: () => {
        return (
          !having_login?.value ||
          having_login.value === 1 ||
          having_login.value === 2
        );
      },
    },
    {
      type: "DATE",
      width: 3,
      name: "start_date",
      element: {
        label: "From date",
        isRequired: true,
        inputType: "BORDER_LABEL",
        maxDate: watch().end_date ?? new Date(),
      },
      hideFunction: () => {
        return (
          !having_login?.value ||
          having_login.value === 1 ||
          having_login.value === 3 ||
          having_login.value === 4
        );
      },
    },
    {
      type: "DATE",
      width: 3,
      name: "end_date",
      element: {
        label: "To date",
        isRequired: true,
        inputType: "BORDER_LABEL",
        minDate: watch().start_date ?? new Date(),
      },
      hideFunction: () => {
        return (
          !having_login?.value ||
          having_login.value === 1 ||
          having_login.value === 3 ||
          having_login.value === 4
        );
      },
    },
    {
      type: "BUTTON",
      width: 1.5,
      name: "submit_button",
      class_name: "is-flex is-justify-content-ends is-align-items-end",
      element: {
        label: "Generate",
        classList: ["button", "smart-action-button"],
        onClick: handleSubmit(onSubmit),
      },
      hideFunction: () => {
        return !having_login?.value || Array.isArray(having_login.value);
      },
    },
  ];

  return (
    <div>
      <div className="title is-4">{""}</div>
      <div className="mb-5">
        <SdsForm elements={elements} errors={errors} control={control} />
      </div>
      {/* {selectedReport === 1 && formData && <Zone />} */}
      {selectedReport === 2 && formData && <SessionReport dataIn={tabData} />}
      {selectedReport === 3 && formData && (
        <ProjectSessionReport dataIn={tabData} />
      )}
      {selectedReport === 4 && formData && (
        <ProjectTraineereport dataIn={tabData} />
      )}
    </div>
  );
};

export default Reports;
